/**
 * The page shell.
 *
 * The masthead carries the IHQ logo and the portal name. There is no footer:
 * it used to render the compliance sentence from the contract, and that
 * sentence was removed deliberately, with nothing in its place. The portal
 * makes no compliance claim in its own chrome; that content belongs in the
 * documents it serves.
 */

import type { ReactNode } from 'react';

import { PORTAL_NAME, PORTAL_WORDMARK_ALT } from '../copy';

interface PageFrameProps {
  /** Shown next to the wordmark once we know who the visitor is. */
  customerName?: string;
  children: ReactNode;
}

export function PageFrame({ customerName, children }: PageFrameProps) {
  return (
    <div className="page">
      <header className="masthead">
        <div className="masthead-inner">
          <p className="wordmark">
            <img src="/brand/ihq-logo.png" alt={PORTAL_WORDMARK_ALT} height={26} />
            <span>{PORTAL_NAME}</span>
          </p>
          {customerName === undefined ? null : <p className="customer">{customerName}</p>}
        </div>
      </header>
      <main className="content">{children}</main>
    </div>
  );
}
